import { incentives } from "../../service/constants";

export default function Incentives() {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-18 sm:px-2 sm:py-16 lg:px-4">
        <div className="max-w-2xl mx-auto px-4 grid grid-cols-1 gap-y-10 gap-x-8 lg:max-w-none lg:grid-cols-3">
          {incentives.map((incentive, idx) => (
            <div
              key={idx}
              className="text-center sm:flex sm:text-left lg:block lg:text-center"
            >
              <div className="sm:flex-shrink-0">
                <div className="flow-root w-16 h-16 mx-auto">
                  <img
                    className="w-full h-full mx-auto"
                    src={incentive.imageSrc}
                    alt=""
                  />
                </div>
              </div>
              <div className="mt-3 sm:mt-0 sm:ml-3 lg:mt-3 lg:ml-0">
                <h3 className="font-medium text-gray-900 mt-10">
                  {incentive.name}
                </h3>
                <p className="mt-2 text-sm text-gray-500"></p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
